import { Injectable, Injector } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
} from '@angular/common/http';

import { Observable, throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';

import { GlobalService } from '../../services/global.service';
import { IRefreshToken } from '../../interfaces/global.interface';

@Injectable()
export class AuthorizationInterceptor implements HttpInterceptor {
  constructor(private injector: Injector) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    // Skip public API
    if (request.url.includes('https://api.postalpincode.in/pincode/')) {
      return next.handle(request);
    }

    const token =
      sessionStorage.getItem('accessToken') ||
      sessionStorage.getItem('verifyToken');

    const tokenType = this.getTokenType(token);

    if (token) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`,
          'X-Frame-Options':
            'DENY, SAMEORIGIN, ALLOW-FROM https://dev.app.dgt.netoyed.com.au/',
        },
      });
    }

    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401 && token) {
          const authService = this.injector.get(GlobalService);

          return authService.onRefreshToken().pipe(
            switchMap((newToken: IRefreshToken) => {
              if (tokenType) {
                sessionStorage.setItem(tokenType, newToken.accessToken);
              }
              const retryRequest = request.clone({
                setHeaders: {
                  Authorization: `Bearer ${newToken.accessToken}`,
                },
              });

              return next.handle(retryRequest);
            }),
            catchError((refreshError) => {
              return throwError(() => refreshError);
            }),
          );
        }

        return throwError(() => error);
      }),
    );
  }

  private getTokenType(token: string | null): string | null {
    if (token === sessionStorage.getItem('accessToken')) return 'accessToken';
    if (token === sessionStorage.getItem('accessToken')) return 'accessToken';
    if (token === sessionStorage.getItem('verifyToken')) return 'verifyToken';
    return null;
  }
}
